<div class="admin-modal">
  <h2 class="title">Cancel booking</h2>
  <p class="subtitle">{{ data.booking.userFullName }} · {{ data.booking.slotStartAt | date:'EEE d MMM, HH:mm' }}</p>
  <p class="hint">The slot will be freed and the consultation step reopened so the user can rebook.</p>

  <label class="field">
    <span>Reason <em>*</em></span>
    <textarea name="reason" rows="3" [(ngModel)]="reason"
              placeholder="Why is this booking being cancelled?"></textarea>
  </label>

  <div class="actions">
    <button type="button" class="btn ghost" (click)="close()">Keep booking</button>
    <button type="button" class="btn danger" [disabled]="!isValid" (click)="submit()">Cancel booking</button>
  </div>
</div>
